import eventosRotas from './eventos/rotas.js';
import contasEventosRotas from './contasEventos/rotas.js';
import expositoresRotas from './expositores/rotas.js';
import certificadosRotas from './certificados/rotas.js';
import impressorasRotas from './impressoras/rotas.js';

const routes = {
    path: 'checkins',
    name: 'Checkins',
    component: () => import('./Checkins.vue'),
    children: [
        eventosRotas,
        contasEventosRotas,
        certificadosRotas,
        expositoresRotas,
        impressorasRotas
    ],
    meta: {
        rules: [...eventosRotas.meta.rules, ...contasEventosRotas.meta.rules, ...certificadosRotas.meta.rules, ...expositoresRotas.meta.rules, ...impressorasRotas.meta.rules],
    },
};

export default routes;
